export const cpGreen = "#378084";
export const cpOrange = "#f26122";
